import type { ReactElement, ReactNode } from 'react';
import React from 'react';
import NavTabs from 'atom-components/nav-tabs-lite';
import MainLayout from 'layouts/main';
import { MarkingPath } from 'pages/marking/routes';
import MarkingAllocationPolicy from 'policies/marking-allocation.policy';
import MarkingGroupPolicy from 'policies/marking-group.policy';
import { usePageAccess } from 'services/providers/page-access.provider';

type Props = {
  children: ReactNode;
};

export default function MarkingPageLayout({ children }: Props): ReactElement {
  const { authorisableUser } = usePageAccess();

  return (
    <MainLayout
      title="Marking"
      navigationTabs={
        <NavTabs>
          <NavTabs.Item href={MarkingPath.MarkerDashboard}>Marker Dashboard</NavTabs.Item>
          {MarkingAllocationPolicy.allocate(authorisableUser) && (
            <>
              <NavTabs.Item href={MarkingPath.MarkingAllocation}>Marking Allocation</NavTabs.Item>
              <NavTabs.Item href={MarkingPath.MarksForReview}>Marks for Review</NavTabs.Item>
            </>
          )}
          {MarkingGroupPolicy.list(authorisableUser) && (
            <NavTabs.Item href={MarkingPath.MarkingGroups}>Marking Groups</NavTabs.Item>
          )}
        </NavTabs>
      }
    >
      {children}
    </MainLayout>
  );
}
